"use client"

import { useEffect, useState } from "react"

export type Language = "ja" | "en" | "zh"

const LANG_STORAGE_KEY = "sophy-language"

export function t(lang: Language, ja: string, en: string, zh?: string): string {
  if (lang === "zh") return zh ?? ja
  if (lang === "en") return en
  return ja
}

export function useLanguage() {
  const [language, setLanguage] = useState<Language>("ja")

  useEffect(() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem(LANG_STORAGE_KEY) as Language | null
      if (saved) setLanguage(saved)
    }
  }, [])

  return language
}
